
import GwHero from '~/patterns/molecules/hero/hero.vue';
export default {
    components: {
        GwHero
    },
};
